module.exports = __webpack_public_path__ + "static/media/explosion_sheet.2e0f02be.svg";